// src/client/components/profile-manager/detail-view/ToggleField.tsx

import { Switch } from '@client/components/ui/switch';

interface ToggleFieldProps {
  label: string;
  checked: boolean;
  onToggle: (checked: boolean) => Promise<void>;
  disabled?: boolean;
}

export default function ToggleField({
  label,
  checked,
  onToggle,
  disabled = false,
}: ToggleFieldProps) {
  const handleToggle = async (newChecked: boolean) => {
    try {
      await onToggle(newChecked);
    } catch (error) {
      console.error('[ToggleField] Toggle failed:', error);
    }
  };

  return (
    <div className="flex items-center justify-between py-2 border-b">
      <label className="text-sm font-medium text-gray-700">{label}:</label>
      <Switch
        checked={checked}
        onCheckedChange={handleToggle}
        disabled={disabled}
      />
    </div>
  );
}